import * as React from 'react';
export var Breadcrumbs = function (_a) {
    var children = _a.children;
    return (<ul className='flex text-gray-500 text-xs px-4'>{children}</ul>);
};
Breadcrumbs.displayName = 'UI.Breadcrumbs';
export var BreadcrumbsLinkItem = function (_a) {
    var children = _a.children, href = _a.href;
    return (<li className='inline-flex items-center'>
		<a className='underline text-cogvio-900 font-semibold' href={href}>
			{children}
		</a>
		<svg className='h-5 w-auto text-gray-400' fill='currentColor' viewBox='0 0 20 20'>
			<path clipRule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' fillRule='evenodd'/>
		</svg>
	</li>);
};
BreadcrumbsLinkItem.displayName = 'UI.BreadcrumbsLinkItem';
export var BreadcrumbsActiveItem = function (_a) {
    var children = _a.children;
    return (<li className='inline-flex items-center text-gray-600'>{children}</li>);
};
BreadcrumbsActiveItem.displayName = 'UI.BreadcrumbsActiveItem';
